// Period
export const PERIOD = {
    HOUR: 0,
    WEEK: 1,
    MONTH: 2,
    DAY: 3,
    SIX_HOUR: 4,
    THREE_HOUR: 5,
};

// Element ___ List period
export const ELEMENT_LIST_PERIOD = [
    {
        label: '3 HOURS',
        value: PERIOD.THREE_HOUR
    },
    {
        label: '6 HOURS',
        value: PERIOD.SIX_HOUR
    },
    {
        label: 'DAY',
        value: PERIOD.DAY
    },
    {
        label: 'WEEK',
        value: PERIOD.WEEK
    },
    {
        label: 'MONTH',
        value: PERIOD.MONTH
    },
];

// Fixed rental status
export const FIXED_RENTAL_STATUS = {
    SUCCESS: 1,
    BALANCE_NOT_ENOUGH: 2,
    MACHINE_NOT_AVAILABLE: 3,
    MACHINE_SHUDOWN_INPROGRESS: 4,
    MACHINE_NOT_READY: 5
};

// Price properties name
export const PRICE_PROPERTIES_NAME = {
    "0": "priceHour",
    "1": "priceWeek",
    "2": "priceMonth",
    "3": "priceDay",
    "4": "priceSixHour",
    "5": "priceThreeHour",
}

// Price unit
export const PRICE_UNIT = {
    "1": "week",
    "2": "month",
    "3": "day",
    "4": "6 hour",
    "5": "3 hour",
}

// Price unit
export const PERIOD_TO_HOUR = {
    "1": 24 * 7,
    "2": 24 * 30,
    "3": 24,
    "4": 6,
    "5": 3,
}
